"use client";
import { ReviewBadge } from "../../design1/components/Testimonials";
import React from "react";
import Pagination from "./Pagination";
import { NavigateIcon } from "./Pagination";
import { TestimonialsType } from "../../../constants/testimonialsData";
import { GroupHeader } from "../../../ui/Headers";
import { useTestimonialsCarousel } from "src/app/lib/useTestimonials";
import Image from "next/image";
const Testimonials = () => {
  const {
    emblaRef,
    selectedIndex,
    scrollSnaps,
    emblaApi,
    canScrollNext,
    canScrollPrev,
    onDotButtonClick,
    testimonials,
  } = useTestimonialsCarousel();

  if (testimonials?.length === 0) return null;
  return (
    <section className="py-14 pt-0 pb-24 overflow-hidden">
      <div className="wrapper">
        <GroupHeader
          max={1200}
          subheader="Read authentic feedback from our satisfied clients, sharing their experiences and success stories with our services."
          header="Feedback from Our Customers"
        />
        <div className="relative  ">
          {canScrollPrev && (
            <div
              onClick={() => emblaApi && emblaApi.scrollPrev()}
              className="prev z-[20] top-1/2 -translate-y-1/2 absolute -left-[60px] transform rotate-[180deg]"
            >
              <NavigateIcon />
            </div>
          )}

          {canScrollNext && (
            <div
              onClick={() => emblaApi && emblaApi.scrollNext()}
              className="next absolute top-1/2 z-[20] -translate-y-1/2    -right-[60px]"
            >
              <NavigateIcon />
            </div>
          )}

          <div ref={emblaRef} className="items overflow-hidden gap-4 ">
            <div className="flex">
              {testimonials?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className=" w-full pr-8 select-none flex justify-center shrink-0"
                  >
                    <TestimonialsCard key={index} {...item} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="pagination">
          <Pagination
            scrollSnaps={scrollSnaps}
            selectedIndex={selectedIndex}
            onDotButtonClick={onDotButtonClick}
            emblaApi={emblaApi}
          />
        </div>
      </div>
    </section>
  );
};
export default Testimonials;

const TestimonialsCard: React.FC<TestimonialsType> = ({
  image,
  name,
  comment,
  reviewType,
}) => {
  return (
    <div className="relative py-6 w-full max-w-[80%] md:w-[80%] mx-auto text-secondary-main flex items-center flex-col">
      <QuoteIcon />
      <Image
        height={112}
        width={112}
        className="size-[7rem] block mb-5 rounded-full"
        src={image as string}
        alt=""
      />
      <p className="text-center max-w-[800px] mb-4">{comment}</p>
      <h4 className="mb-3">{name}</h4>
      <div className="!text-sm">
        <ReviewBadge flag reviewType={reviewType} />
      </div>
    </div>
  );
};

const QuoteIcon = () => {
  return (
    <div className="absolute left-0">
      <svg
        width="64"
        height="55"
        viewBox="0 0 64 55"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29 50H4.125V25.1L14.1 5.15H26.5L16.575 25.1H29V50Z"
          fill="var(--primary-color)"
        />
        <path
          d="M61 50H36.125V25.1L46.1 5.15H58.5L48.575 25.1H61V50Z"
          fill="var(--primary-color)"
        />
      </svg>
    </div>
  );
};
